import { render } from "./App.vue?vue&type=template&id=634d578a"
const script = {}

import exportComponent from "C:\\Users\\admin\\Desktop\\tuoanzhishengwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__